<template>
  <div class="productAddForm">
    <el-form
      :model="basicForm"
      :size="$store.state.formSize"
      :rules="basicFormRules"
      ref="refBasicForm"
      label-width="150px"
      :inline="true"
    >
      <el-form-item label="产品名称：" prop="productName" class="is-required">
        <el-input v-model="basicForm.productName" :disabled="codeDisabled" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="产品商标：" prop="productTrademark">
        <el-input v-model="basicForm.productTrademark" autocomplete="off" ></el-input>
      </el-form-item>
      <el-form-item label="商品条码：" prop="barcode">
        <el-input v-model="basicForm.barcode" :disabled="codeDisabled" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="产品规格：">
        <el-input
          v-model="basicForm.specification"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属一级分类：" prop="categoryLevel1">
        <el-select
          v-model="basicForm.categoryLevel1"
          :placeholder="basicForm.categoryLevelName1"
          @change="categoryLevelChange2"
          style="width:100%;"
        >
          <el-option
            v-for="item in categoryLevel1List"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属二级分类：" prop="categoryLevel2">
        <el-select
          v-model="basicForm.categoryLevel2"
          :disabled="selectDisabled2"
          :placeholder="basicForm.categoryLevelName2"
          @change="categoryLevelChange3"
          style="width:100%;"
        >
          <el-option
            v-for="item in categoryLevel2List"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属三级分类：" prop="categoryLevel3">
        <el-select
          v-model="basicForm.categoryLevel3"
          :disabled="selectDisabled3"
          :placeholder="basicForm.categoryLevelName3"
          @change="categoryLevelChange4"
          style="width:100%;"
        >
          <el-option
            v-for="item in categoryLevel3List"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属四级分类：" prop="categoryLevel4">
        <el-select
          v-model="basicForm.categoryLevel4"
          :disabled="selectDisabled4"
          :placeholder="basicForm.categoryLevelName4"
          style="width:100%;"
        >
          <el-option
            v-for="item in categoryLevel4List"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品状态：" prop="productState">
        <el-select v-model="basicForm.productState" style="width:100%;">
          <el-option
            v-for="item in productStateList"
            :key="item.label"
            :value="item.value"
            :label="item.label"
            >{{ item.label }}</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item label="保质期：" class="is-required">
        <el-select v-model="basicForm.shelfLifeNum" class="shelfLife">
          <el-option v-for="item in 120" :key="item" :value="item">{{ item }}</el-option>
        </el-select>
        <el-select v-model="basicForm.shelfLifeStr" class="shelfLife">
          <el-option value="月">月</el-option>
          <el-option value="年">年</el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="二维码头部信息：" prop="qrcodeHead">
        <el-input v-model="basicForm.qrcodeHead" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="二维码尾部信息：" prop="qrcodeFoot">
        <el-input v-model="basicForm.qrcodeFoot" autocomplete="off"></el-input>
      </el-form-item> -->
      <el-form-item label="产品类别：" prop="productType">
        <el-select v-model="basicForm.productType" style="width:100%;">
          <el-option
            v-for="item in productTypeList"
            :key="item.label"
            :value="item.value"
            :label="item.label"
            >{{ item.label }}</el-option
          >
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="标准号：">
        <el-input v-model="basicForm.standardNo" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="标准名称：">
        <el-input
          v-model="basicForm.standardName"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="标准分类：">
        <el-select v-model="basicForm.standardType">
          <el-option label="1" value="1"></el-option>
          <el-option label="2" value="2"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="产品防伪说明：" class="my-textarea">
        <el-input
          v-model="basicForm.productDescription"
          type="textarea"
          :rows="5"
        ></el-input>
      </el-form-item>
      <el-form-item label="产品图片：" class="my-textarea">
        <el-upload
          style="width: 60vw;"
          action="#"
          ref="upload"
          list-type="picture-card"
          :http-request="handleHttpRequest"
          :limit="5"
          :class="fileList.length === this.limitSize ? 'disabled-upload' : ''"
          :file-list="initFileList"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="text-right" style="margin-right: 280px;">
      <el-button
        type="primary"
        :size="$store.state.buttonSize"
        :disabled="isDisabled"
        @click="debounceSubmit"
        >保 存</el-button
      >
      <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <div style="padding-top: 20px;">
        <img width="100%" :src="dialogImageUrl" alt />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import { postProductEdit, putProductAdd, getProductDetail, getProductName } from '@/api/product'
import { postWfsImg } from '@/api/common'
import { getCategoryList } from '@/api/category'

const createForm = () => ({
  // *商品条码
  barcode: '',
  // *分类
  categoryLevel1: null,
  categoryLevel2: null,
  categoryLevel3: null,
  categoryLevel4: null,
  categoryLevelName1: '',
  categoryLevelName2: '',
  categoryLevelName3: '',
  categoryLevelName4: '',
  // *产品类别  1：初级农产品；0：加工品（默认初级农产品）
  productType: 1,
  // 防伪说明
  productDescription: '',
  // 产品图片，附件表id
  productImg1: '',
  productImg2: '',
  productImg3: '',
  productImg4: '',
  productImg5: '',
  imgUrl1: '',
  imgUrl2: '',
  imgUrl3: '',
  imgUrl4: '',
  imgUrl5: '',
  // *产品名称
  productName: '',
  // *产品状态  1、在产；2、停产
  productState: 1,
  // *产品商标
  productTrademark: '',
  // 保质期(字符串拼接)
  shelfLife: '',
  shelfLifeNum: '',
  shelfLifeStr: '',
  // 产品规格
  specification: '',
  // 标准名称
  standardName: '',
  // 标准号
  standardNo: '',
  // 标准分类
  standardType: null,
  // ID
  id: undefined,
  // 二维码尾部信息
  qrcodeFoot: '',
  // 二维码头部信息
  qrcodeHead: ''
})

const createRules = () => ({
  categoryLevel1: [
    { required: true, message: '请选择产品分类', trigger: 'blur' }
  ],
  categoryLevel2: [
    { required: true, message: '请选择产品分类', trigger: 'blur' }
  ],
  categoryLevel3: [
    { required: true, message: '请选择产品分类', trigger: 'blur' }
  ],
  categoryLevel4: [
    { required: true, message: '请选择产品分类', trigger: 'blur' }
  ],
  productType: [
    { required: true, message: '请选择产品类别', trigger: 'blur' }
  ],
  productState: [
    { required: true, message: '请选择产品状态', trigger: 'blur' }
  ],
  productName: [
    { validator: createCheck(getProductName, '请输入产品名称'), trigger: 'blur' }
  ],
  barcode: [
    { required: false, message: '请输入商品条码', trigger: 'blur' }
  ],
  productTrademark: [
    { required: false, message: '请输入产品商标', trigger: 'blur' }
  ]
})

const createCheck = (checkFn, message) => (rule, value, callback) => {
  if (value === '') {
    callback(new Error(message))
  } else {
    checkFn(value).then(res => {
      if (res.status === 2) {
        callback(new Error(res.msg))
      } else {
        callback()
      }
    })
  }
}

export default {
  data() {
    return {
      basicForm: createForm(),
      currentID: this.id,
      isDisabled: false,
      codeDisabled: false,
      dialogImageUrl: '',
      dialogVisible: false,
      selectDisabled2: true,
      selectDisabled3: true,
      selectDisabled4: true,
      productTypeList: [
        {
          value: 1,
          label: '初级农产品'
        },
        {
          value: 0,
          label: '加工品'
        }
      ],
      productStateList: [
        {
          value: 1,
          label: '在产'
        },
        {
          value: 2,
          label: '停产'
        }
      ],
      basicFormRules: createRules(),
      fileList: [],
      // const
      limitSize: 5,
      categoryLevel1List: [],
      categoryLevel2List: [],
      categoryLevel3List: [],
      categoryLevel4List: [],
      pathList: [],
      initFileList: []
    }
  },
  props: {
    drawer: Boolean,
    id: {
      type: Number,
      default: null
    },
    isEdit: Boolean
  },
  created() {
    this.debounceSubmit = debounce(300, this.basicFormSubmit)
    this.basicFormPopup()
  },
  mounted() {
    this.$watch(
      () => this.$refs.upload.uploadFiles,
      val => {
        this.fileList = val
      }
    )
    this.getCategoryListData()
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      this.pathList.splice(index, 1)
      this.$refs.upload.handleRemove(file)
    },
    handleBeforeUpload() {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleHttpRequest(option) {
      const formData = new FormData()

      if (option.data) {
        Object.keys(option.data).forEach(key => {
          formData.append(key, option.data[key])
        })
      }

      formData.append(option.filename, option.file)

      postWfsImg(formData).then(res => {
        if (res.status === 1) {
          this.pathList.push(res.data.filePath)
        } else {
          this.$message.error(res.msg || '图片上传失败')
        }
      }).catch(() => {
        this.$message.error('图片上传失败')
      })
    },
    hanleResetFormVals() {
      this.$emit('cancel', false)
    },
    // 提交
    basicFormSubmit() {
      if (this.currentID) {
        delete this.basicFormRules.productName
        delete this.basicFormRules.barcode
      } else {
        this.$set(this, 'basicFormRules', createRules())
      }

      this.$refs.refBasicForm.validate(valid => {
        if (!valid) return false

        let gStr = ''
        if (this.basicForm.shelfLifeStr === '月') gStr = '个'
        this.basicForm.shelfLife = this.basicForm.shelfLifeNum + gStr + this.basicForm.shelfLifeStr

        const saveBasicForm = this.currentID ? postProductEdit : putProductAdd

        this.pathList.forEach((path, i) => {
          if (path.indexOf('/trace/wfs/img/') > -1) {
            // WFS 图片：从展示URL提取 WFS 文件名（新上传的本身就是文件名，会走 else 分支）
            this.basicForm[`productImg${i + 1}`] = path.substring(path.indexOf('/trace/wfs/img/') + '/trace/wfs/img/'.length)
          } else if (path.indexOf('30102/common/web/file/') > -1) {
            this.basicForm[`productImg${i + 1}`] = path.substr(43)
          } else if (path.indexOf('9002/common/web/file/') > -1) {
            // https://www.ydtncpzlzs.cn:9002/common/web/file/
            this.basicForm[`productImg${i + 1}`] = path.substr(47)
          } else if (path.indexOf('9000/common/web/file/') > -1) {
            // https://www.ydtncpzlzs.cn:9002/common/web/file/
            this.basicForm[`productImg${i + 1}`] = path.substr(47)
          } else {
            this.basicForm[`productImg${i + 1}`] = path
          }
          console.log(path)
        })
        saveBasicForm(this.basicForm).then(res => {
          if (res.status === 1) {
            if (res.data) {
              this.$emit('paneStatus', false)
              this.$emit('success', res.data)
              this.basicForm.id = this.currentID = res.data
              this.$message.success('新增基本信息成功')
            } else {
              this.basicForm.id = this.currentID
              this.$message.success('编辑基本信息成功')
            }
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 新建/编辑表单初始化
    basicFormPopup() {
      if (this.currentID) {
        this.isDisabled = true
        this.$emit('paneStatus', false)

        getProductDetail(this.currentID).then(res => {
          if (res.status === 1) {
            console.log(res)
            this.codeDisabled = true
            const keys = (
              'barcode,categoryLevel1,categoryLevel2,categoryLevel3,categoryLevel4,categoryLevelName1,' +
              'categoryLevelName2,categoryLevelName3,categoryLevelName4,productType,productName,productState,productTrademark,' +
              'specification,standardName,standardNo,standardType,productDescription,id,imgUrl1,imgUrl2,imgUrl3,imgUrl4,imgUrl5,qrcodeHead,qrcodeFoot'
            ).split(',')

            new Array(5)
              .fill(null)
              .map((_, i) => `imgUrl${i + 1}`)
              .forEach(key => {
                const url = res.data[key]
                if (url) {
                  this.initFileList.push({ url })

                  this.pathList.push(url)
                }
              })

            keys.forEach(key => {
              this.basicForm[key] = res.data[key]
            })

            this.basicForm.shelfLife = res.data.shelfLife
            this.basicForm.shelfLifeNum = parseInt(res.data.shelfLife)
            if (res.data.shelfLife.indexOf === '年') {
              this.basicForm.shelfLifeStr = '年'
            } else {
              this.basicForm.shelfLifeStr = '月'
            }
            getCategoryList(res.data.categoryLevel1).then(res => {
              if (res.status === 1) {
                const arr = []
                for (let i = 0; i < res.data.length; i++) {
                  arr.push({
                    label: res.data[i].name,
                    value: res.data[i].id
                  })
                }
                this.categoryLevel2List = arr
                this.selectDisabled2 = false
              } else {
                this.$message.error(res.msg)
              }
            })
            getCategoryList(res.data.categoryLevel2).then(res => {
              if (res.status === 1) {
                const arr = []
                for (let i = 0; i < res.data.length; i++) {
                  arr.push({
                    label: res.data[i].name,
                    value: res.data[i].id
                  })
                }
                this.categoryLevel3List = arr
                this.selectDisabled3 = false
              } else {
                this.$message.error(res.msg)
              }
            })
            getCategoryList(res.data.categoryLevel3).then(res => {
              if (res.status === 1) {
                const arr = []
                for (let i = 0; i < res.data.length; i++) {
                  arr.push({
                    label: res.data[i].name,
                    value: res.data[i].id
                  })
                }
                this.categoryLevel4List = arr
                this.selectDisabled4 = false
              } else {
                this.$message.error(res.msg)
              }
            })

            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$emit('paneStatus', true)
      }
    },
    // 一级分类列表
    getCategoryListData() {
      getCategoryList(0).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              label: res.data[i].name,
              value: res.data[i].id
            })
          }
          this.categoryLevel1List = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 二级列表选择
    categoryLevelChange2(val) {
      this.basicForm.categoryLevel2 = ''
      this.basicForm.categoryLevelName2 = ''
      this.basicForm.categoryLevel3 = ''
      this.basicForm.categoryLevelName3 = ''
      this.basicForm.categoryLevel4 = ''
      this.basicForm.categoryLevelName4 = ''
      getCategoryList(val).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              label: res.data[i].name,
              value: res.data[i].id
            })
          }
          this.categoryLevel2List = arr
          this.selectDisabled2 = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 三级列表选择
    categoryLevelChange3(val) {
      this.basicForm.categoryLevel3 = ''
      this.basicForm.categoryLevelName3 = ''
      this.basicForm.categoryLevel4 = ''
      this.basicForm.categoryLevelName4 = ''
      getCategoryList(val).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              label: res.data[i].name,
              value: res.data[i].id
            })
          }
          this.categoryLevel3List = arr
          this.selectDisabled3 = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 四级列表选择
    categoryLevelChange4(val) {
      this.basicForm.categoryLevel4 = ''
      this.basicForm.categoryLevelName4 = ''
      getCategoryList(val).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              label: res.data[i].name,
              value: res.data[i].id
            })
          }
          this.categoryLevel4List = arr
          this.selectDisabled4 = false
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="scss" scoped>
.productAddForm  ::v-deep {
  .el-form-item__content {
    width: 173px;
  }
  .shelfLife {
    width: 86.5px!important;
  }
  .el-textarea__inner {
    width: 60vw!important;
  }
  .disabled-upload ::v-deep .el-upload {
    display: none;
  }
}
</style>
